import React, { useState, useMemo } from 'react';
import {
  Card,
  Row,
  Col,
  Button,
  Badge,
  Table,
  Alert,
  ProgressBar,
  Form,
  InputGroup,
} from 'react-bootstrap';
import {
  BarChart,
  Download,
  Printer,
  InfoCircle,  
  GraphUp,
  Calendar,
  Cash,

  CheckCircle, 
  Clock,
  Hospital

} from 'react-bootstrap-icons';

// Données fictives
const financialData = {
  totalReimbursements: 12500000,
  totalPaid: 11875000,
  pending: 625000,
  monthlyData: [
    { month: 'Jan 2025', reimbursements: 980000, paid: 950000 },
    { month: 'Fév 2025', reimbursements: 1020000, paid: 990000 },
    { month: 'Mar 2025', reimbursements: 1150000, paid: 1120000 },
  ],
  byStructure: [
    { name: 'CHU Libreville', amount: 3250000 },
    { name: 'Pharmacie Centrale', amount: 2180000 },
    { name: 'Clinique Ambroise Paré', amount: 1560000 },
    { name: 'Pharmacie Moderne', amount: 1240000 },
    { name: 'Hôpital Régional', amount: 980000 },
  ],
};

const FinancialReports = () => {
  const [exporting, setExporting] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [periodFilter, setPeriodFilter] = useState('month');

  const handleExport = () => {
    setExporting(true);
    setTimeout(() => {
      alert('Export PDF (simulation)');
      setExporting(false);
    }, 800);
  };

  const handlePrint = () => {
    setPrinting(true);
    setTimeout(() => {
      window.print();
      setPrinting(false);
    }, 500);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR').format(amount) + ' FCFA';
  };

  const totalReimbursed = financialData.totalReimbursements;
  const totalPaid = financialData.totalPaid;
  const pending = financialData.pending;
  const paymentRate = Math.round((totalPaid / totalReimbursed) * 100);

  const statsCards = [
    {
      title: 'Total remboursements',
      value: formatCurrency(totalReimbursed),
      icon: Cash,
      color: '#4361ee',
      gradient: 'linear-gradient(135deg, #4361ee 0%, #3b2a9f 100%)',
      bg: 'white',
    },
    {
      title: 'Déjà versé',
      value: formatCurrency(totalPaid),
      icon: CheckCircle,
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      bg: 'white',
    },
    {
      title: 'En attente',
      value: formatCurrency(pending),
      icon: Clock,
      color: '#f59e0b',
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      bg: 'white',
    },
    {
      title: 'Taux de paiement',
      value: `${paymentRate}%`,
      icon: GraphUp,
      color: '#06b6d4',
      gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
      bg: 'white',
    },
  ];

  return (
    <div className="" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="container-fluid">
        {/* En-tête */}
        <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div>
            <h4 className="main-title mb-0 d-flex align-items-center gap-2">
              <div className="bg-primary bg-opacity-10 rounded-circle p-2">
                <BarChart size={24} className="text-primary" />
              </div>
              Rapports financiers
            </h4>
            <p className="text-muted mb-0 mt-1">
              Consultez les états financiers des remboursements
            </p>
          </div>
       
<Row className="g-2 align-items-center">
  
  {/* FILTRE */}
  <Col xs={12} md="auto">
    <InputGroup>
      <InputGroup.Text className="bg-light border-0">
        <Calendar size={14} />
      </InputGroup.Text>
      <Form.Select
        value={periodFilter}
        onChange={(e) => setPeriodFilter(e.target.value)}
        className="border-0 bg-light"
      >
        <option value="month">Ce mois</option>
        <option value="quarter">Ce trimestre</option>
        <option value="year">Cette année</option>
      </Form.Select>
    </InputGroup>
  </Col>

  {/* EXPORT */}
  <Col xs={12} md="auto">
    <Button
      variant="outline-primary"
      className="w-100 w-md-auto rounded-pill px-3"
      onClick={handleExport}
      disabled={exporting}
    >
      <Download size={14} className="me-1" />
      {exporting ? "Export..." : "Exporter"}
    </Button>
  </Col>

  {/* PRINT */}
  <Col xs={12} md="auto">
    <Button
      variant="outline-secondary"
      className="w-100 w-md-auto rounded-pill px-3"
      onClick={handlePrint}
      disabled={printing}
    >
      <Printer size={14} className="me-1" />
      {printing ? "Préparation..." : "Imprimer"}
    </Button>
  </Col>

</Row>
        </div>

        {/* Cartes de statistiques */}
        <Row className="g-3 mb-4">
          {statsCards.map((card, idx) => (
            <Col md={6} lg={3} xs={6} key={idx}>
              <Card className="border-0 shadow-sm stats-card h-100" style={{ borderRadius: '16px', background: card.bg }}>
                <div className="card-gradient" style={{ background: card.gradient, height: '4px' }}></div>
                <Card.Body className="p-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <h6 className="text-muted mb-1 small fw-semibold text-uppercase" style={{ letterSpacing: '0.5px' }}>
                        {card.title}
                      </h6>
                      <h3 className="mb-0 fw-bold" style={{ fontSize: '1.2rem' }}>
                        {card.value}
                      </h3>
                    </div>
                    {/* <div className="icon-container rounded-3 d-flex align-items-center justify-content-center" style={{ background: `${card.color}20`, width: '48px', height: '48px' }}>
                      <card.icon size={28} style={{ color: card.color }} />
                    </div> */}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Tableau des remboursements mensuels */}
        <Row className="mb-4">
          <Col md={12}>
            <Card className="border-0 shadow-sm" style={{ borderRadius: '16px', overflow: 'hidden' }}>
              <Card.Header className="bg-white border-0 pt-4 pb-4 px-4">
                <h5 className="fw-semibold mb-0 d-flex align-items-center gap-2">
                  <GraphUp size={18} className="text-primary" />
                  Évolution mensuelle des remboursements
                </h5>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="table-responsive">
                  <Table hover className="mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th>Mois</th>
                        <th>Demandes (FCFA)</th>
                        <th>Versements (FCFA)</th>
                        <th>Taux de paiement</th>
                        </tr>
                      </thead>
                    <tbody>
                      {financialData.monthlyData.map((item, idx) => {
                        const rate = Math.round((item.paid / item.reimbursements) * 100);
                        return (
                          <tr key={idx}>
                            <td className="fw-medium">{item.month}</td>
                            <td className="text-end">{formatCurrency(item.reimbursements)}</td>
                            <td className="text-end">{formatCurrency(item.paid)}</td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div className="progress flex-grow-1" style={{ height: '6px' }}>
                                  <div className="progress-bar bg-success" style={{ width: `${rate}%` }}></div>
                                </div>
                                <span className="small fw-medium">{rate}%</span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Tableau par structure */}
        <Row>
          <Col md={12}>
            <Card className="border-0 shadow-sm" style={{ borderRadius: '16px', overflow: 'hidden' }}>
              <Card.Header className="bg-white border-0 pt-4 pb-4 px-4">
                <h5 className="fw-semibold mb-0 d-flex align-items-center gap-2">
                  <Hospital size={18} className="text-primary" />
                  Top 5 structures par montant remboursé
                </h5>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="table-responsive">
                  <Table hover className="mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th>Structure</th>
                        <th>Montant remboursé</th>
                        <th>Part (%)</th>
                        </tr>
                      </thead>
                    <tbody>
                      {financialData.byStructure.map((item, idx) => (
                        <tr key={idx}>
                          <td className="fw-medium">{item.name}</td>
                          <td className="fw-bold text-success">{formatCurrency(item.amount)}</td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <div className="progress flex-grow-1" style={{ height: '6px' }}>
                                <div
                                  className="progress-bar bg-primary"
                                  style={{ width: `${(item.amount / financialData.totalReimbursements) * 100}%` }}
                                ></div>
                              </div>
                              <span className="small fw-medium">
                                {Math.round((item.amount / financialData.totalReimbursements) * 100)}%
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Information */}
        <Row className="mt-4">
          <Col md={12}>
            <Alert variant="info" className="border-0 rounded-3 shadow-sm" style={{ background: 'linear-gradient(135deg, #e8f4fd 0%, #d9eaff 100%)' }}>
              <div className="d-flex align-items-center gap-3">
                <InfoCircle size={24} className="text-info" />
                <div>
                  <strong className="d-block mb-1">Rapports financiers</strong>
                  <span className="small">
                    Les données sont actualisées quotidiennement. Utilisez les filtres pour affiner la période.
                  </span>
                </div>
              </div>
            </Alert>
          </Col>
        </Row>

        <style>{`
          .stats-card {
            position: relative;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            border-radius: 16px;
            overflow: hidden;
          }
          .stats-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12) !important;
          }
          .card-gradient {
            transition: height 0.2s ease;
          }
          .stats-card:hover .card-gradient {
            height: 6px;
          }
          .icon-container {
            transition: transform 0.2s ease;
          }
          .stats-card:hover .icon-container {
            transform: scale(1.05);
          }
          .progress {
            background-color: #e9ecef;
          }
          .progress-bar {
            border-radius: 4px;
          }
          .table > :not(caption) > * > * {
            padding: 0.75rem 0.75rem;
            vertical-align: middle;
          }
        `}</style>
      </div>
    </div>
  );
};

export default FinancialReports;